import Item from "./item";

export default class Row {
	constructor(items = {}) {
		this.items = Object.entries(items).reduce((acc, [key, item]) => {
			acc[key] = new Item(item);
			return acc;
		}, {});
	}
	getItems() {
		return this.items;
	}
}
